export default __webpack_public_path__ + "static/media/appstore-logo.2c2bb37b.png";